import React, { useState, useEffect,useCallback } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
  Navigate,
} from "react-router-dom";
import Login2 from "./pages/Login2";
import NewVersionToast from "./components/NewVersionToast/NewVersionToast";
import Dashboard from './pages/Dashboard/Dashboard';
import PaymentBreakdown from './pages/Dashboard/PaymentBreakdown';
import HolidayCalendar from './pages/Holidays/HolidayCalendar';
import DashboardNext from './pages/Dashboard/DashboardNext';
import MemberList from './pages/MemberList/MemberList';
import BulkHolidayWhatsapp from "./pages/BulkHolidayWhatsapp/BulkHolidayWhatsapp";
import NewMember from './pages/MemberList/NewMember';
import Payment from "./pages/Payment/Payment";
import AddUser from "./pages/User/AddUser";
import AddEmployees from "./pages/Employees/AddEmployees";
import InvoicePage from './pages/Invoices/Invoice';
import UserList from "./pages/User/UserList";
import MemberDetails from "./pages/MemberList/MemberDetails";
import MemberListContainer from "./pages/MemberList/MemberListContainer";

import EmployeesDetail from "./pages/Employees/EmployeesDetail";
import OfferLetter from './pages/Employees/OfferLetter'; // adjust path accordingly
import EmployeeAgreement from './pages/Employees/EmployeeAgreement.jsx';
import SalaryGeneration from './pages/Employees/SalaryGeneration.jsx';
import ListDueUsers from "./pages/ListDueUsers/ListDueUsers";
import ManagePackage from "./pages/ManagePackage/ManagePackage";
// import OfferPackage from "./pages/OfferPackage/OfferPackage";
import ParentOfferPackage from "./pages/OfferPackage/ParentOfferPackage";
import AddOfferPackage from "./pages/OfferPackage/AddOfferPackage";
import Attendance from "./pages/Attendance/Attendance.jsx";
import MonthlyAttendance from "./pages/Attendance/MonthlyAttendance.jsx";
import MonthlyAttendanceDetail from "./pages/Attendance/MonthlyAttendanceDetail.jsx";
import ForgetPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ConfirmPassword.jsx';
import AddNonMember from "./pages/OfferPackage/AddNonMember";
import BalanceSheet from "./pages/BalanceSheet/BalanceSheet.jsx";
import AllPayment from "./pages/BalanceSheet/AllPayment.jsx";
import FollowUP from "./pages/FollowUps/FollowUP.jsx";
import DietChatPage from "./pages/DietChatPage/DietChatPage.jsx";
import CreateDietChart from "./pages/DietChatPage/CreateDietChart.jsx";
import DietAssignUser from "./pages/DietChatPage/DietAssignUser.jsx";
import ExerciseListPage from "./pages/ExercisePage/ExerciseListPage.jsx";
import CreateExercise from "./pages/ExercisePage/CreateExercise.jsx";
import ExerciseAssignUser from "./pages/ExercisePage/ExerciseAssignUser.jsx";
import ExpenseListPage from "./pages/ExpensePage/ExpenseListPage.jsx";
import PtpaymentManagement from "./pages/PtpaymentManagement/PtpaymentManagement.jsx";
import OperationLogsPage from "./pages/OperationLogs/OperationLogsPage.jsx";
import DeviceCommandLogsPage from "./pages/DeviceCommandLogs/DeviceCommandLogsPage.jsx";
import { PathProvider } from './pages/Includes/PathContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { MenuLayoutProvider } from './contexts/MenuLayoutContext';
import ChatBot from './components/ChatBot/ChatBot';
import useEnterToSubmit from './hooks/useEnterToSubmit';
import Test from "./Test.js";
function App() {
  useEnterToSubmit();
  const AUTO_LOGOUT_TIME = 8 * 60 * 60 * 1000; // 8 hours in milliseconds

  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;
  const ASSET_PATH = process.env.PUBLIC_URL;
  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  const [userData, setUserData] = useState(() => {
    const storedData = localStorage.getItem("userdata");
    return storedData ? JSON.parse(storedData) : null;
  });

  const checkUserData = () => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      return <Navigate to="/" />;
    }
    setUserData(JSON.parse(storedData));
    return null;
  };
  window.constants = {
    //api_url: "http://127.0.0.1:8000/api", //local
    // api_url: "https://mtt-mg.examot.com/api",  //live
    // api_url: "http://145.223.21.251/mttmg-api/api",
    api_url: "https://mttmg.cloud/mttmg-api/api",
    asset_path: ASSET_PATH,
    base_path: 'https://54.236.17.116/deep-delve-hindalco/' //live
  };
    useEffect(() => {
      const storedData = localStorage.getItem("userdata");
      if (!storedData) {
        // User is not logged in, no need to redirect
        return;
      }
  
      setUserData(JSON.parse(storedData));
    }, []);
    const PrivateRoute = ({ element }) => {
      return userData ? element : checkUserData();
    };
    const handleLogout = useCallback(() => {
      localStorage.removeItem("userdata");
      setUserData(null);
      window.location.href = "/"; // Redirect to login
    }, []);
  
    // Auto-logout timer management
    useEffect(() => {
      // Function to reset the timeout
      const resetTimeout = () => {
        clearTimeout(logoutTimer);
        logoutTimer = setTimeout(handleLogout, AUTO_LOGOUT_TIME);
      };
  
      // Add event listeners for user activity
      window.addEventListener("mousemove", resetTimeout);
      window.addEventListener("keydown", resetTimeout);
      window.addEventListener("scroll", resetTimeout);
      window.addEventListener("click", resetTimeout);
  
      // Initialize timeout
      let logoutTimer = setTimeout(handleLogout, AUTO_LOGOUT_TIME);
  
      // Cleanup on component unmount
      return () => {
        clearTimeout(logoutTimer);
        window.removeEventListener("mousemove", resetTimeout);
        window.removeEventListener("keydown", resetTimeout);
        window.removeEventListener("scroll", resetTimeout);
        window.removeEventListener("click", resetTimeout);
      };
    }, [handleLogout]);
  return (
    <ThemeProvider>
    <PathProvider>
    <MenuLayoutProvider>
    <Routes>
      
      <Route path="/" element={<Login2 />} />
      <Route
                path="/reset-password"
                element={<ResetPassword />}
              />
                  <Route
                path="/test"
                element={<Test />}
              />
                <Route
                path="/forgotpassword"
                element={<ForgetPassword />}
              />
      <Route
                path="/dashboard"
                element={<PrivateRoute element={<Dashboard />} />}
              />

      <Route
                path="/dashboard-next"
                element={<PrivateRoute element={<DashboardNext />} />}
              />
      <Route
                path="/payment-breakdown"
                element={<PrivateRoute element={<PaymentBreakdown />} />}
              />
      <Route
                path="/holiday-calendar"
                element={<PrivateRoute element={<HolidayCalendar />} />}
              />
                <Route
                path="/Followup-visitors"
                element={<PrivateRoute element={<FollowUP />} />}
              />
                 <Route
                path="/memberList"
                element={<PrivateRoute element={<MemberList />} />}
              />
              <Route
                path="/bulk-holiday-whatsapp"
                element={<PrivateRoute element={<BulkHolidayWhatsapp />} />}
              />
              
                <Route
                path="/balance-sheet"
                element={<PrivateRoute element={<BalanceSheet />} />}
              />
               <Route
                path="/all-payment-bydate"
                element={<PrivateRoute element={<AllPayment />} />}
              />
                <Route
                path="/invoice"
                element={<PrivateRoute element={<InvoicePage />} />}
              />
    <Route
                path="/newmember"
                element={<PrivateRoute element={<NewMember />} />}
              />
     <Route
                path="/memberdetails"
                element={<PrivateRoute element={<MemberDetails />} />}
              />
              
      <Route
                path="/userlist"
                element={<PrivateRoute element={<UserList />} />}
              />
     <Route
                path="/attendance-sheet"
                element={<PrivateRoute element={<Attendance />} />}
              />
   <Route
                path="/adduser"
                element={<PrivateRoute element={<AddUser />} />}
              /><Route
              path="/addemployees"
              element={<PrivateRoute element={<AddEmployees />} />}
            />

       <Route
                path="/payment"
                element={<PrivateRoute element={<Payment />} />}
              />
     <Route
                path="/listdueusers"
                element={<PrivateRoute element={<ListDueUsers />} />}
              />
                <Route
                path="/managepackage"
                element={<PrivateRoute element={<ManagePackage />} />}
              />
                <Route
                path="/ParentOfferPackage"
                element={<PrivateRoute element={<ParentOfferPackage />} />}
              />
               <Route
                path="/addnonmember"
                element={<PrivateRoute element={<AddNonMember />} />}
              />
                <Route
                path="/addofferpackage"
                element={<PrivateRoute element={<AddOfferPackage />} />}
              />
              
                <Route
                path="/employeesdetail"
                element={<PrivateRoute element={<EmployeesDetail />} />}
              />
                <Route
                path="/offer-letter"
                element={<PrivateRoute element={<OfferLetter />} />}
              />
                <Route
                path="/employee-agreement"
                element={<PrivateRoute element={<EmployeeAgreement />} />}
              />
               <Route
                path="/monthly-attendance"
                element={<PrivateRoute element={<MonthlyAttendance />} />}
              />
              <Route
                path="/salary-generation"
                element={<PrivateRoute element={<SalaryGeneration />} />}
              />
              <Route
                path="/monthly-attendance-detail"
                element={<PrivateRoute element={<MonthlyAttendanceDetail />} />}
              />
               <Route
                path="/trainer-wise-member"
                element={<PrivateRoute element={<PtpaymentManagement />} />}
              />
      <Route
                path="/diet-chart"
                element={<PrivateRoute element={<DietChatPage />} />}
              />
                  <Route
                path="/create-chart"
                element={<PrivateRoute element={<CreateDietChart />} />}
              />
      <Route
                path="/diet-assign-user"
                element={<PrivateRoute element={<DietAssignUser />} />}
              />
      <Route
                path="/exercise-list"
                element={<PrivateRoute element={<ExerciseListPage />} />}
              />
      <Route
                path="/create-exercise"
                element={<PrivateRoute element={<CreateExercise />} />}
              />
      <Route
                path="/exercise-assign-user"
                element={<PrivateRoute element={<ExerciseAssignUser />} />}
              />
      <Route
                path="/expense-list"
                element={<PrivateRoute element={<ExpenseListPage />} />}
              />
      <Route
                path="/operation-logs"
                element={<PrivateRoute element={<OperationLogsPage />} />}
              />
      <Route
                path="/device-command-logs"
                element={<PrivateRoute element={<DeviceCommandLogsPage />} />}
              />
    </Routes>
    {userData && pathname !== '/' && <ChatBot />}
    <NewVersionToast />
    </MenuLayoutProvider>
    </PathProvider>
    </ThemeProvider>
  );
}
export default App;
